import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import NewSelect from '../Select/Select'

class MissionSelectMultiple extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    values: PropTypes.array,
    disabled: PropTypes.bool,
    options: PropTypes.array,
  }

  constructor(props) {
    super(props)

    this.state = {
      missions: [],
      error: null,
      loading: false,
    }
  }

  componentDidMount() {
    const { user, options } = this.props

    if (!options) {
      this.setState({ loading: true })
      return new Api(user.dsToken)
        .get(API_URL.MISSION_LIST)
        .then((response) => this.onFetchSuccess(response.data))
        .catch((error) => this.onFetchError(error))
    }
  }

  onFetchSuccess(missions) {
    const options = missions.map((mission) => ({
      value: mission.cdMission,
      label: mission.dsMission,
    }))
    this.setState({ missions: options, loading: false, error: null })
  }

  onFetchError(error) {
    this.setState({ error, loading: false, missions: [] })
  }

  handleText = (string) =>
    `${this.props.translate('mission-list.create-option')} ${string}`

  render() {
    const { name, values, onChange, translate, disabled, options } = this.props
    const { missions, loading } = this.state

    const label = loading
      ? translate('mission-edit.loading')
      : translate('mission-edit.choose-mission')

    return (
      <>
        <NewSelect
          label={translate('missions')}
          placeholder={label}
          required
          options={options || missions}
          onChange={(event) => onChange(event)}
          isMulti
          value={values}
          fill
          name={name}
          disabled={disabled}
        />
      </>
    )
  }
}

export default MissionSelectMultiple
